module.exports = __webpack_public_path__ + "img/1.23_Russian_road_sign.949adea2.svg";